/* First Pair Guarantee buttons, ported from BoxerBriefGuaranteeSection.tsx.
   Shop -> scroll back to the s1-pdp top (divider under the sticky header,
   same coordinate math as the selection cards). Learn More -> centre the
   FAQ section in the viewport. */

class S1Guarantee extends HTMLElement {
  connectedCallback() {
    /* fade-ins (opt-in "reveal" setting): .s1-gtee-fade + IntersectionObserver,
       same contract as .s1-ch-fade. Sections without the setting render no
       fade elements and skip this entirely. */
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-gtee-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));

    if (this._initialized) return;
    this._initialized = true;

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-s1-gtee-shop]')) {
        const pdp = document.querySelector('s1-pdp');
        if (pdp) {
          const margin = parseFloat(getComputedStyle(pdp).scrollMarginTop) || 0;
          const top = Math.max(0, pdp.getBoundingClientRect().top + window.scrollY - margin);
          window.scrollTo({ top, behavior: 'smooth' });
        }
        return;
      }
      if (e.target.closest('[data-s1-gtee-learn]')) {
        document.getElementById('s1-faq')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
  }
}

if (!customElements.get('s1-guarantee')) customElements.define('s1-guarantee', S1Guarantee);
